import { useState } from "react";

/**
 * Custom hook to manage hot spot product data and loading state
 */
export const useHotSpotProduct = () => {
  const [productData, setProductData] = useState({
    catalogImage: null,
    catalogImageAlternateText: null,
    childProductName: null,
    productDescription: null,
    productCode: null,
    ctaLink: null,
    isProPlanet: false,
    isCompostable: false,
    isAddBrand: false,
    isNew: false,
  });

  const [loading, setLoading] = useState(false);
  const [fetchError, setFetchError] = useState(false);

  /**
   * Load and parse product data from API response
   */
  const loadProduct = (product) => {
    if (!product) {
      clearProduct();
      return;
    }

    setLoading(true);

    setProductData({
      catalogImage: product.catalogImage || null,
      catalogImageAlternateText: product.catalogImageAlternateText || null,
      childProductName: product.childProductName || null,
      productDescription: null, // Not used in current implementation
      productCode: product.productCode || null,
      ctaLink: product.url || null,
      isProPlanet: Boolean(product.isProPlanet),
      isCompostable: Boolean(product.isCompostable),
      isAddBrand: Boolean(product.isPrintable || product.isEmbossable),
      isNew: Boolean(product.isNewProduct),
    });

    setLoading(false);
  };

  /**
   * Reset all product data
   */
  const clearProduct = () => {
    setProductData({
      catalogImage: null,
      catalogImageAlternateText: null,
      childProductName: null,
      productDescription: null,
      productCode: null,
      ctaLink: null,
      isProPlanet: false,
      isCompostable: false,
      isAddBrand: false,
      isNew: false,
    });
    setLoading(false);
    setFetchError(false);
  };

  return {
    productData,
    loading,
    fetchError,
    loadProduct,
    clearProduct,
  };
};
